import AsyncStorage from '@react-native-async-storage/async-storage';

import { decodeCookie, createCookieString } from './cookie';

export const asyncStorageCookie = (name: string) => ({
  get: async () => {
    const stored = await AsyncStorage.getItem(name);
    return decodeCookie(name, stored || '');
  },
  set: async (value: string, domain: string) => {
    const toStore = createCookieString(
      name,
      value,
      Number.POSITIVE_INFINITY,
      domain
    );
    await AsyncStorage.setItem(name, toStore);
  },
  remove: () => AsyncStorage.removeItem(name),
});
